export default {
  labels: {
    dont_have_account: 'Eikö sinulla ole tiliä? ',
  },
  title: 'Liity {{name}}!',
  default_program_name: 'Kanta-asiakasohjelma',
  buttons: {
    sign_up: 'Rekisteröidy',
  },
};
